// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previousCT{
    padding: 10rem 0rem;
    position: relative;
    flex-direction: column;
    z-index: 4;
    clip-path: polygon(20% 0, 100% 18%, 100% 87%, 80% 100%, 0 88%, 0 19%);    
    margin-top: 3rem;
}
.prevDot1{
    position: absolute;
    z-index: 10 !important;
    left: -3.5rem;
    margin-top: -1rem;
}
.prevDot2{
    position: absolute;
    z-index: 10 !important;
    right: -4rem;
    margin-top: -5rem;
}

.PreviousCT_button{
    padding: 0rem 15rem;
    width: 100%;
}
.PreviousCT_button>button{
    padding: 1rem 1rem 1rem 1rem;
    text-align: center;
    align-self: flex-start;
    border: solid 0.1px;
}
.text_previousCT{
    padding: 0rem 15rem;
}
.text_previousCT>h3{
    text-align: left;
    width: min-intrinsic;
    width: min-content;
    display: table-caption;
    display: -ms-grid;
    -ms-grid-columns: min-content;
}
.speaker2022{
    display: grid;
    grid-template-columns:repeat(12,1fr);
    gap: 0.5rem;
    z-index: 2;
    padding: 0rem 8rem;
    width: 100%;
}
.speaker22Div{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.8rem;
    width: 100%; 
}
.speakerimg22{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0.1rem 0.1rem;
    box-sizing: border-box;
    border-radius: 50%;
    border: 4px solid transparent;
    margin: 0.1rem 0.1rem;
}
.speakerimg22>img{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: white;
    border: 1px solid transparent;
    box-sizing: border-box;
}
.speaker22Div>small{
    width: min-intrinsic;
    width: min-content;
    display: table-caption;
    display: -ms-grid;
    -ms-grid-columns: min-content;
   text-align: center;
   height: 70%;
}
.prevBtn{
    text-decoration: underline;
    text-decoration-thickness: 2px;
    margin-left: 74%;
    padding: 0.5rem 0rem;
}


@media only screen and (max-width: 1200px) {
    .previousCT{
        height: auto;
        padding: 10rem 0rem;
    }
    .previousCT>button{
     margin-right: 0%;
    
    }
    .text_previousCT{
        padding: 0rem 10rem;
        gap: 1rem;
        flex-direction: column;
    }
    
    .speaker2022{
        grid-template-columns:repeat(6,1fr);
    }
    .prevBtn{
        margin-left: 74%;
    }
}
@media only screen and (max-width: 1000px) {
    .prevDot1{
        left: -6rem;
        margin-top: -1rem;
    }
    .prevDot2{
        right: -6rem;
        margin-top: -5rem;
    }
}
@media only screen and (max-width: 800px) {
    .speaker2022{
        grid-template-columns:repeat(6,1fr);
        padding: 0rem 3rem;

    }
    .speakerimg22{
        border: 2px solid transparent;
    }
    .speaker22Div>small{
        height: 3rem;
        margin-bottom: 0.5rem;
    }
    .text_previousCT{
        padding: 0rem 3rem;
        gap: 1rem;
        flex-direction: column;
    }
    .prevBtn{
        margin-left: 64%;
    }
    .previousCT{
        clip-path: polygon(27% 0, 100% 5%, 100% 97%, 75% 100%, 0 96%, 0 3%);
            }
    .prevDot1{
        display: none;
    }
    .prevDot2{
        display: none;
    }
}
@media only screen and (max-width: 550px) {
    .previousCT{
        height: auto;
        padding: 5rem 0rem;
    }
    .text_previousCT{
        padding: 0rem 2rem;
    }
    .speaker2022{
        padding: 0rem 2rem;
        grid-template-columns:repeat(3,1fr);
    }
    .speakerimg22{
        border: 2px solid transparent;
    }
    .speaker22Div>small{
        height: 3rem;
        margin-bottom: 0.8rem;
    }
    .prevBtn{
        margin-left: 54%;
    }
    .PreviousCT_button {
        padding: 0rem 2rem;
    }
}
@media only screen and (max-width: 450px) {
    .speaker2022{
        grid-template-columns:repeat(2,1fr);
    }
    .prevBtn{
        margin-left: 44%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/PreviousCT/PreviousCT.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,qEAAqE;IACrE,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,oBAAoB;IAGpB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,oBAAoB;IAGpB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,6BAA6B;GAC9B,kBAAkB;GAClB,WAAW;AACd;AACA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;AACxB;;;AAGA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;KACC,gBAAgB;;IAEjB;IACA;QACI,mBAAmB;QACnB,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,mCAAmC;IACvC;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,mCAAmC;QACnC,kBAAkB;;IAEtB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,YAAY;QACZ,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mEAAmE;YAC/D;IACR;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,mCAAmC;IACvC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,YAAY;QACZ,qBAAqB;IACzB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".previousCT{\n    padding: 10rem 0rem;\n    position: relative;\n    flex-direction: column;\n    z-index: 4;\n    clip-path: polygon(20% 0, 100% 18%, 100% 87%, 80% 100%, 0 88%, 0 19%);    \n    margin-top: 3rem;\n}\n.prevDot1{\n    position: absolute;\n    z-index: 10 !important;\n    left: -3.5rem;\n    margin-top: -1rem;\n}\n.prevDot2{\n    position: absolute;\n    z-index: 10 !important;\n    right: -4rem;\n    margin-top: -5rem;\n}\n\n.PreviousCT_button{\n    padding: 0rem 15rem;\n    width: 100%;\n}\n.PreviousCT_button>button{\n    padding: 1rem 1rem 1rem 1rem;\n    text-align: center;\n    align-self: flex-start;\n    border: solid 0.1px;\n}\n.text_previousCT{\n    padding: 0rem 15rem;\n}\n.text_previousCT>h3{\n    text-align: left;\n    width: min-intrinsic;\n    width: -webkit-min-content;\n    width: -moz-min-content;\n    width: min-content;\n    display: table-caption;\n    display: -ms-grid;\n    -ms-grid-columns: min-content;\n}\n.speaker2022{\n    display: grid;\n    grid-template-columns:repeat(12,1fr);\n    gap: 0.5rem;\n    z-index: 2;\n    padding: 0rem 8rem;\n    width: 100%;\n}\n.speaker22Div{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 0.8rem;\n    width: 100%; \n}\n.speakerimg22{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 0.1rem 0.1rem;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border: 4px solid transparent;\n    margin: 0.1rem 0.1rem;\n}\n.speakerimg22>img{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: white;\n    border: 1px solid transparent;\n    box-sizing: border-box;\n}\n.speaker22Div>small{\n    width: min-intrinsic;\n    width: -webkit-min-content;\n    width: -moz-min-content;\n    width: min-content;\n    display: table-caption;\n    display: -ms-grid;\n    -ms-grid-columns: min-content;\n   text-align: center;\n   height: 70%;\n}\n.prevBtn{\n    text-decoration: underline;\n    text-decoration-thickness: 2px;\n    margin-left: 74%;\n    padding: 0.5rem 0rem;\n}\n\n\n@media only screen and (max-width: 1200px) {\n    .previousCT{\n        height: auto;\n        padding: 10rem 0rem;\n    }\n    .previousCT>button{\n     margin-right: 0%;\n    \n    }\n    .text_previousCT{\n        padding: 0rem 10rem;\n        gap: 1rem;\n        flex-direction: column;\n    }\n    \n    .speaker2022{\n        grid-template-columns:repeat(6,1fr);\n    }\n    .prevBtn{\n        margin-left: 74%;\n    }\n}\n@media only screen and (max-width: 1000px) {\n    .prevDot1{\n        left: -6rem;\n        margin-top: -1rem;\n    }\n    .prevDot2{\n        right: -6rem;\n        margin-top: -5rem;\n    }\n}\n@media only screen and (max-width: 800px) {\n    .speaker2022{\n        grid-template-columns:repeat(6,1fr);\n        padding: 0rem 3rem;\n\n    }\n    .speakerimg22{\n        border: 2px solid transparent;\n    }\n    .speaker22Div>small{\n        height: 3rem;\n        margin-bottom: 0.5rem;\n    }\n    .text_previousCT{\n        padding: 0rem 3rem;\n        gap: 1rem;\n        flex-direction: column;\n    }\n    .prevBtn{\n        margin-left: 64%;\n    }\n    .previousCT{\n        clip-path: polygon(27% 0, 100% 5%, 100% 97%, 75% 100%, 0 96%, 0 3%);\n            }\n    .prevDot1{\n        display: none;\n    }\n    .prevDot2{\n        display: none;\n    }\n}\n@media only screen and (max-width: 550px) {\n    .previousCT{\n        height: auto;\n        padding: 5rem 0rem;\n    }\n    .text_previousCT{\n        padding: 0rem 2rem;\n    }\n    .speaker2022{\n        padding: 0rem 2rem;\n        grid-template-columns:repeat(3,1fr);\n    }\n    .speakerimg22{\n        border: 2px solid transparent;\n    }\n    .speaker22Div>small{\n        height: 3rem;\n        margin-bottom: 0.8rem;\n    }\n    .prevBtn{\n        margin-left: 54%;\n    }\n    .PreviousCT_button {\n        padding: 0rem 2rem;\n    }\n}\n@media only screen and (max-width: 450px) {\n    .speaker2022{\n        grid-template-columns:repeat(2,1fr);\n    }\n    .prevBtn{\n        margin-left: 44%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
